import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { apiService } from 'app/services/api.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  socialMediaData: any[] = [];
  generalData: any = {};
  downloadAppData: any = {};
  isRtl: boolean = false;
  languageCode: string = '';
  companyName : any;

  constructor(private router: Router, private api: apiService) { }

  openTab(tab: string) {
    this.router.navigate(['/cms'], { queryParams: { tab: tab } });
    window.scrollTo(0, 0);
  }

  ngOnInit(): void {
    this.languageCode = localStorage.getItem('languageCode') || 'en';
    this.loadData();
    this.isRtl = document.dir === 'rtl';
  }

  loadData() {
    // Call all three APIs
    this.api.getSocialMedia().subscribe(
      (socialMediaResponse) => {
        if (socialMediaResponse.success) {
          this.socialMediaData = socialMediaResponse.data;
        } else {
          console.error('Failed to fetch social media data.');
        }
      },
      (socialMediaError) => {
        console.error('Error fetching social media data:', socialMediaError);
      }
    );

    this.api.getGeneral().subscribe(
      (generalResponse) => {
        if (generalResponse.success) {
          this.generalData = generalResponse.data;
          this.companyName = generalResponse.data.organizationName;
        } else {
          console.error('Failed to fetch general data.');
        }
      },
      (generalError) => {
        console.error('Error fetching general data:', generalError);
      }
    );

    this.api.getDownloadApp(this.languageCode).subscribe(
      (downloadAppResponse) => {
        if (downloadAppResponse.success) {
          this.downloadAppData = downloadAppResponse.data;
        } else {
          console.error('Failed to fetch downloadapp data.');
        }
      },
      (downloadAppError) => {
        console.error('Error fetching downloadapp data:', downloadAppError);
      }
    );
  }

  getImageSrc() {
    // Use the bannerImageEn and bannerImageAr values from the downloadAppData
    const rtlImageDownloadSrc = this.downloadAppData.banner_image;
    const ltrImageDownloadSrc = this.downloadAppData.banner_image;

    // Return the appropriate image source based on the value of isRtl
    return this.isRtl ? rtlImageDownloadSrc : ltrImageDownloadSrc;
  }


}
